<template>
<TransitionRoot as="template" :show="speakerModalState.show">
  <Dialog as="div" class="fixed z-10 inset-0 overflow-y-auto" @close="speakerModalState.show = false">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
        <div class="inline-block my-auto bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 align-middle w-full sm:max-w-xl sm:w-full sm:p-6">
          <button type="button" class="absolute top-4 right-4 bg-black rounded-full p-1 text-white hover:bg-gray-700" @click="speakerModalState.show = false">
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <img :src="speakerModalState.speaker.img" alt="" class="w-full h-full object-cover">
          <h3 class="mt-4 font-display text-2xl font-bold tracking-tight text-slate-900">{{ speakerModalState.speaker.name }}</h3>
          <p class="text-lg tracking-tight text-gray-500 italic">{{ speakerModalState.speaker.venue }} Venue {{ speakerModalState.speaker.role }}</p>
          <p class="mt-4 text-lg tracking-tight text-gray-600">{{ speakerModalState.speaker.bio }}</p>
        </div>
      </TransitionChild>
    </div>
  </Dialog>
</TransitionRoot>
</template>

<script setup>
import { Dialog, DialogOverlay, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { useEvents } from '@/composables/useEvents'
const { speakerModalState } = useEvents()
</script>
